import { ChangeDetectionStrategy, Component, computed, input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { ProductConfigurationConfigurableOptionValue } from '@df/module-product-configuration/model/configurable/options/product-configuration-configurable-option-value';
import { BgContrastDirective } from '@df/ui/atomic/atom/color/bg-contrast.directive';
import { UiComponent } from '@df/ui/ui.component';

@Component({
    selector: '[productLayoutConfigurableOptionsSwatch]',
    exportAs: 'productLayoutConfigurableOptionsSwatch',
    templateUrl: './product-layout-configurable-options-swatch.component.html',
    styleUrl: './product-layout-configurable-options-swatch.component.scss',
    imports: [DfImageDirective],
    hostDirectives: [
        {
            directive: BgContrastDirective,
            inputs: ['bgContrast', 'tolerance:bgContrastTolerance']
        }
    ],
    host: {
        '[class.is-selected]': 'isSelected()',
        '[class.is-disabled]': 'isDisabled()',
        '[style.background-color]': 'type() === "background" ? swatch() : undefined',
        '[style.border-color]': 'type() === "background" ? swatch() : undefined'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutConfigurableOptionsSwatchComponent extends UiComponent implements OnChanges {
    readonly item = input<ProductConfigurationConfigurableOptionValue>();
    readonly value = input<number>();
    readonly isSelected = input(false);
    readonly isDisabled = input(false);
    readonly alt = input('');
    readonly option = signal<Catalog.IAttributeOption | undefined>(undefined);

    readonly type = computed(() => {
        const option = this.option();

        if (option && typeof option !== 'string') {
            if (option.hasImage) {
                return 'image';
            }

            return 'background';
        }

        return undefined;
    });

    readonly swatch = computed(() => {
        const option = this.option();

        if (option && typeof option !== 'string') {
            return option.swatch || '';
        }

        return '';
    });

    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);

        const item = this.item();
        const value = this.value();

        if (changes['item'] && item && value) {
            this.option.set(item.attribute.getOptionByValue(value));
        }
    }
}
